import React from 'react';
import Slider from 'react-slick';
import './Banner.scss';
import { odPushGA4Event } from '../../../../utils/gaFour';
import { useSelector } from 'react-redux';

const Banner = () => {
  const userInfo = useSelector(state => state.common.userInfo);

  const settings = {
    vertical: true, // Enables vertical scrolling
    verticalSwiping: true,
    autoplay: true,
    autoplaySpeed: 3000, // Change every 3 seconds
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const handleShopNowClick = () => {
    odPushGA4Event('top_banner_outlet_sale_click', {
      userInfo,
    });
  };

  return (
    <div className="odBanner">
      <Slider {...settings} className="odBanner__slider">
        <div className="odBanner__slide odBanner__doubleSaving">
          Double saving, 50% off on your 2nd pair of glasses
        </div>

        <div className="odBanner__slide odBanner__outletSale">
          Outlet Sale | Limited Stock
          <a
            className="odBanner__shopNowCta od_link"
            href="/sg/en/campaign/outlet.html"
            onClick={handleShopNowClick}
          >
            <span>Shop now</span>
            <img
              alt="shop now"
              className="odBanner__shopNowCtaImg"
              src="https://static.lenskart.com/media/owndays/minified/arrow-right.webp"
            />
          </a>
        </div>
      </Slider>
    </div>
  );
};

export default Banner;
